var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('side-card', {
    attrs: {
      "absolute": true,
      "loading": _vm.loading,
      "width": !_vm.fullscreenBreakpoint ? '1200px' : '100%',
      "hideTitle": true,
      "fullscreen": _vm.fullscreenBreakpoint
    },
    on: {
      "close": _vm.close
    }
  }, [_c('repair-estimate-detail', {
    attrs: {
      "value": _vm.value,
      "loading": _vm.loading,
      "hideBreadCrumbs": "",
      "showDetailButton": ""
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.loading = $event;
      },
      "delete": _vm.emitDeleteEstimate
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }